'use client';

import { motion } from 'framer-motion';

import { DemoMessage } from 'models/DemoMessage';

import styles from './styles.module.css';

interface MessageProps {
	message: string;
	index: number;
	messages: DemoMessage[];
}

function Message(props: MessageProps) {
	return (
		<motion.div
			className={styles.message}
			initial={
				props.index === props.messages.length - 1 &&
				props.messages.length > 1
					? {
							y: -45,
							opacity: 0,
							filter: 'blur(5px)',
						}
					: props.index === 0 && props.messages.length === 1
						? {
								y: 45,
								opacity: 0,
								filter: 'blur(5px)',
							}
						: false
			}
			animate={{
				zIndex: props.index + 1,
				scale: 1 - (props.messages.length - 1 - props.index) * 0.03,
				opacity: 1 - (props.messages.length - 1 - props.index) * 0.3,
				y: (props.messages.length - 1 - props.index) * 45,

				filter: 'blur(0px)',
			}}
			transition={{ duration: 0.3 }}
		>
			<span>{props.message}</span>
		</motion.div>
	);
}

export default Message;
